// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserPermissionManagement_main__taMhh {
    width: 100%;
    height: 100%;
}

.UserPermissionManagement_header__UJTwW {
    height: 35px;
    margin-bottom: 25px;
}

.UserPermissionManagement_title__p4uhJ {
    font-size: 30px;
}

.UserPermissionManagement_container__7Eh19 {
    width: 100%;
    min-height: calc(100% - 60px);
    padding: 20px;
    border-radius: 6px;
    background-color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/UserPermissionManagement/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B","sourcesContent":[".main {\n    width: 100%;\n    height: 100%;\n}\n\n.header {\n    height: 35px;\n    margin-bottom: 25px;\n}\n\n.title {\n    font-size: 30px;\n}\n\n.container {\n    width: 100%;\n    min-height: calc(100% - 60px);\n    padding: 20px;\n    border-radius: 6px;\n    background-color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `UserPermissionManagement_main__taMhh`,
	"header": `UserPermissionManagement_header__UJTwW`,
	"title": `UserPermissionManagement_title__p4uhJ`,
	"container": `UserPermissionManagement_container__7Eh19`
};
export default ___CSS_LOADER_EXPORT___;
